import React from 'react';
import {createSlice} from '@reduxjs/toolkit';
const Whatsappslice=createSlice(

{

name:"wapp",
initialState:{whapp:[]},
reducers:{

setMessages:(state,action)=>{
  state.whapp=action.payload;
}


}


}
);


export const {setMessages} = Whatsappslice.actions;

export const getMessages=(state)=>state.wapp.whapp;
export default Whatsappslice.reducer;
